<!-- <h3 class="text-center">{{data.graphname}}</h3> -->

<div dir="ltr">
    <div class="m-2 d-inline-block ppp-calander">

        <p-calendar class="ppp-calander"
        [(ngModel)]="endDate"
        [dateFormat]="'dd MM yy'"
        [minDate]="startDate"
        [maxDate]="today"
        (ngModelChange)="onDateChange()"
        [showIcon]="true"
        [showButtonBar]="true"
        [inputStyle]="{'text-align': 'right'}"
        >
        </p-calendar>
        <label  class="m-2 ms-label-view">{{"End Date" | translator }}</label>

    </div>


    <div class="m-2 d-inline-block ppp-calander">

        <p-calendar
        [(ngModel)]="startDate"
        [dateFormat]="'dd MM yy'"
        [maxDate]="endDate"
        (ngModelChange)="onDateChange()"
        [showIcon]="true"
        [showButtonBar]="true"
        [inputStyle]="{'text-align': 'right'}">
        </p-calendar>
        <label class="m-2 ms-label-view">{{"Start Date" | translator }}</label>

    </div>
</div>


<div class="v4-graph-bg">
    <p-chart type="bar" [data]="chartData" [options]="chartOptions"></p-chart>
</div>